import { useTelegram } from '../hooks/useTelegram'

/**
 * Атрибуция FatSecret — СТРОГО по их Attribution Policy
 * (https://platform.fatsecret.com/attribution).
 *
 * Первую версию (свой логотип + «Powered by fatsecret» нашим шрифтом) платформа
 * отклонила при рассмотрении заявки на повышение лимита: требуется точный
 * формат — их Web Badge (готовая картинка с их шрифтом) либо их HTML-сниппет,
 * менять который нельзя. Поэтому здесь:
 *  - официальный бейдж с их CDN, с их src/srcset/alt как в примере из policy;
 *  - ссылка ровно на https://platform.fatsecret.com;
 *  - никаких своих подписей, цветов и шрифтов поверх.
 *
 * Клик открывается через Telegram-утилиту openLink: в WebView обычный
 * `<a target="_blank">` не работает (класс проблем из #419). Сам href при этом
 * остаётся — разметка соответствует сниппету policy.
 */

const FATSECRET_PLATFORM_URL = 'https://platform.fatsecret.com'
const BADGE_BASE = 'https://platform.fatsecret.com/api/static/images'

type BadgeTheme = 'brand' | 'white' | 'dark'

export function FatSecretAttribution({
  variant = 'inline',
  theme = 'brand',
  style,
}: {
  /** `inline` — под данными в карточках; `block` — крупнее, для шторок. */
  variant?: 'inline' | 'block'
  /** Вариант официального бейджа под фон: brand / white / dark. */
  theme?: BadgeTheme
  style?: React.CSSProperties
}) {
  const { openLink } = useTelegram()
  const name = `powered_by_fatsecret_horizontal_${theme}`
  // Исходник бейджа 1x — 212×40; держим родные пропорции.
  const height = variant === 'block' ? 24 : 16

  return (
    <a
      href={FATSECRET_PLATFORM_URL}
      onClick={(ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        openLink(FATSECRET_PLATFORM_URL, { external: true })
      }}
      data-testid="fatsecret-attribution"
      style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0, ...style }}
    >
      <img
        alt="Nutrition information provided by fatsecret Platform API"
        src={`${BADGE_BASE}/${name}.png`}
        srcSet={`${BADGE_BASE}/${name}@2x.png 2x, ${BADGE_BASE}/${name}@3x.png 3x`}
        style={{ height, width: 'auto', display: 'block' }}
      />
    </a>
  )
}
